import ConsoleError from '@/modules/core/models/errors/ConsoleError'
import Joi from 'joi'

export default Joi.object({
  businessLine: Joi.string().required(),
  businessLineId: Joi.string().required(),
  maxInsurances: Joi.number().integer().min(0).required(),
  maxDays: Joi.number().integer().min(0).required(),
  stayAbroadTypes: Joi.any().allow(null).optional(),
  billingCycles: Joi.object({
    monthly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    quarterly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    semiannual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  genders: Joi.object({
    female: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    male: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  hiringMaxAges: Joi.object({
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    pets: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insuredRC: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  houseTypes: Joi.object({
    apartment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    house: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  relationships: Joi.array()
    .items(
      Joi.object({
        id: Joi.string().required(),
        text: Joi.string().required(),
        holder: Joi.boolean().required(),
        default: Joi.boolean().required(),
        disabled: Joi.boolean().required(),
        unique: Joi.boolean().required()
      })
    )
    .allow(null)
    .optional(),
  copaymentTypes: Joi.any().allow(null).optional(),
  petTypes: Joi.object({
    dog: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    cat: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  tags: Joi.object({
    holderAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    personalDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    personalDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).optional(),
    contactDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    insuranceInForceAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    civilLiabilityAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactRcDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required()
  }).required()
})
  .error((errors) => {
    const text = `DXP Pets branch configuration - ${errors.map((e) => `"${e.local.label}" is required`).join()}`
    return new ConsoleError({ message: text })
  })
  .unknown(true)
